import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgMedicalShield = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M16.375 9.5C16.375 9.33424 16.3092 9.17527 16.1919 9.05806C16.0747 8.94085 15.9158 8.875 15.75 8.875H13.875V7C13.875 6.83424 13.8092 6.67527 13.6919 6.55806C13.5747 6.44085 13.4158 6.375 13.25 6.375H10.75C10.5842 6.375 10.4253 6.44085 10.3081 6.55806C10.1908 6.67527 10.125 6.83424 10.125 7V8.875H8.25C8.08424 8.875 7.92527 8.94085 7.80806 9.05806C7.69085 9.17527 7.625 9.33424 7.625 9.5V12C7.625 12.1658 7.69085 12.3247 7.80806 12.4419C7.92527 12.5592 8.08424 12.625 8.25 12.625H10.125V14.5C10.125 14.6658 10.1908 14.8247 10.3081 14.9419C10.4253 15.0592 10.5842 15.125 10.75 15.125H13.25C13.4158 15.125 13.5747 15.0592 13.6919 14.9419C13.8092 14.8247 13.875 14.6658 13.875 14.5V12.625H15.75C15.9158 12.625 16.0747 12.5592 16.1919 12.4419C16.3092 12.3247 16.375 12.1658 16.375 12V9.5Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.87503 5.26915V11.6142C3.87505 13.6197 4.4828 15.5781 5.61816 17.2314C6.75353 18.8846 8.36321 20.1549 10.235 20.875L11.1025 21.2083C11.6802 21.4305 12.3198 21.4305 12.8975 21.2083L13.765 20.875C15.6368 20.1549 17.2465 18.8846 18.3819 17.2314C19.5173 15.5781 20.125 13.6197 20.125 11.6142V5.26915C20.1267 5.03036 20.0594 4.79618 19.931 4.5948C19.8027 4.39343 19.6189 4.23345 19.4017 4.13415C17.0682 3.11564 14.546 2.60137 12 2.62498C9.45408 2.60137 6.93183 3.11564 4.59836 4.13415C4.3812 4.23345 4.19738 4.39343 4.06904 4.5948C3.94071 4.79618 3.87333 5.03036 3.87503 5.26915V5.26915Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgMedicalShield.displayName = 'SvgMedicalShield';
export default SvgMedicalShield;
